// Module
var code = `<div ng-repeat="info in vm.infosFinancieres" class="ex-card-infos-financieres-content" ng-if="vm.shouldShowButton(info.fonction)"> <md-button ng-click="vm.open(\$index)" class="ex-card-infos-financieres-button"> <md-icon>assessment</md-icon> {{info.lblTitre | exLibelle}} </md-button> </div> `;
// Exports
module.exports = code;